import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";

export default function CarePlanTable({ carePlans }) {
  return (
    <Paper elevation={2}>
      <Table>
        <TableHead>
          <TableRow>
          <TableCell><strong>Creation Date</strong></TableCell>
          <TableCell><strong>Diagnosis(es)</strong></TableCell>
          <TableCell><strong>Standard(s)</strong></TableCell>
          <TableCell><strong>Status</strong></TableCell>
          <TableCell><strong>Created by</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {carePlans.map((plan) => (
            <TableRow key={plan.patientCarePlanId}>
              <TableCell>{dayjs(plan.createDate).format("DD-MM-YYYY")}</TableCell>
              <TableCell>{plan.diagnosis}</TableCell>
              <TableCell>{plan.standars}</TableCell>
              <TableCell>{plan.status}</TableCell>
              <TableCell>{plan.employee}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}
